import { MileageTripInformationFormFragment } from 'generated/resources/graphql'

export const getTripInformationAttributes = (data: MileageTripInformationFormFragment) => {
  return {
    to: data?.mileage?.to,
    from: data?.mileage?.from,
    originLatitude: data?.mileage?.originLatitude,
    originLongitude: data?.mileage?.originLongitude,
    destinationLatitude: data?.mileage?.destinationLatitude,
    destinationLongitude: data?.mileage?.destinationLongitude,
  }
}
